import type { CompanyDiscoveryAiOutput } from '@revelio/data-access';

import type { Filter } from '../../types/filters';
import { transformEntityInfo } from './transformEntityInfo';
import { transformPrimarySelector } from './transformPrimarySelector';
import { transformSegments } from './transformSegments';

export type ScreenerAiTransformUnknownFilter = {
  name: string;
  relevantPromptText?: string;
  explanation?: string;
};

/**
 * Transforms CompanyDiscoveryAiOutput (backend screener AI response) into CustomDash Filter[].
 * Combines primary selector, segments (with segmentation), and entity info selectors.
 */
export const transformScreenerAiResponseToCustomDashFilters = (
  response: CompanyDiscoveryAiOutput
): {
  filters: Filter[];
  unknownFilters: ScreenerAiTransformUnknownFilter[];
} => {
  const { filters: responseFilters } = response;
  const unknownFilters: ScreenerAiTransformUnknownFilter[] = (
    response.unknownFilters ?? []
  ).map((u) => ({
    name: u.name,
    relevantPromptText: u.relevantPromptText,
    explanation: u.explanation,
  }));

  const filters: Filter[] = [];

  const primaryFilters = transformPrimarySelector(
    responseFilters.primary_selector
  );
  filters.push(...primaryFilters);

  const segmentFilters = transformSegments(responseFilters.segments);
  filters.push(...segmentFilters);

  const companyInfoSelectors =
    responseFilters.entity_info_selectors?.company_info_selectors;
  const entityFilters = transformEntityInfo(companyInfoSelectors);
  filters.push(...entityFilters);

  return { filters, unknownFilters };
};
